/*
  Basari: VisionCarePro lens option fix
  Problem: in the drawer smart layout, unticking the last ticked lens option
  does not clear it. The app clears window.selectedLensTreatments, then its
  getter falls back to the stale window.selectedLensTreatment and puts the
  option back. The option stays selected in the background while the
  checkbox shows unticked, and every later click on it is ignored.
  Fix: when the option being clicked is the only one selected, clear the
  stale single value first so the removal sticks.
  Safe to delete once VisionCarePro fixes this in their app.
*/
(function () {
  'use strict';

  function sameId(a, b) {
    return String(a) === String(b);
  }

  function patch() {
    var original = window.selectLensOptionWithMetafield;
    if (typeof original !== 'function') return false;
    if (original.__basariLensFix) return true;

    var wrapped = function (optionId, optionName, optionPrice, optionDataString, preferredColorIndex) {
      var isColourPick = preferredColorIndex !== null && preferredColorIndex !== undefined;
      if (!isColourPick) {
        var list = Array.isArray(window.selectedLensTreatments) ? window.selectedLensTreatments : [];
        var single = window.selectedLensTreatment;
        var removingLastOne =
          (list.length === 1 && sameId(list[0] && list[0].id, optionId)) ||
          (list.length === 0 && single && sameId(single.id, optionId));
        if (removingLastOne) {
          window.selectedLensTreatment = null;
        }
      }
      return original.apply(this, arguments);
    };

    wrapped.__basariLensFix = true;
    window.selectLensOptionWithMetafield = wrapped;
    return true;
  }

  if (!patch()) {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (patch() || tries > 60) clearInterval(timer);
    }, 500);
  }

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('#select-lens-btn, .select-lens-btn')) {
      patch();
    }
  }, true);
})();